<ln-ln-pages-armor>
  <section body>
    <div class="bg-beige bg-opacity-20 flex flex-col">
    <div class="flex flex-col mt-[30px]">
      <ln-about-us-hero></ln-about-us-hero>
    </div>
    <div class="mx-auto flex max-w-[1440px] flex-col justify-center">
        <div class="flex flex-col mx-[36px] sm:mx-[120px]">
          <!--        quienes somos-->
          <div class="mb-[25px] mt-[32px] text-xl font-semibold text-verde sm:mb-[20px] sm:mt-[30px] sm:text-2xl">
            {{ 'labels.aboutUs' | transloco }}
          </div>
          <div class="text-base font-normal text-cafe">
            {{ 'labels.aboutUsText' | transloco }}
          </div>

          <!--        nuestras areas-->
          <div class="mb-[25px] mt-[32px] text-lg font-semibold text-verde sm:mb-[20px] sm:mt-[30px] sm:text-2xl">
            {{ 'labels.ourAreas' | transloco }}
          </div>
<!--          luna nueva portal-->
          <div class="font-semibold text-lg text-cafe">
            {{ 'labels.lunaNuevaPortal' | transloco }}
          </div>
          <div class="text-base font-normal text-cafe">
            {{ 'labels.lunaNuevaPortalDescription' | transloco }}
          </div>

          <!--          luna nueva Properties-->
          <div class="mt-[25px] sm:mt-[30px] font-semibold text-lg text-cafe">
            {{ 'labels.lunaNuevaProperties' | transloco }}
          </div>
          <div class="text-base font-normal text-cafe">
            {{ 'labels.lunaNuevaPropertiesDescription' | transloco }}
          </div>

          <ul class="list-disc list-inside ml-4 mb-3 mt-6">
              <li class="text-[16px] leading-[25px] font-normal text-[#372121]" [innerHTML]="'labels.usPropertyManaSubTitleList' | transloco"></li>
          </ul>

          <ul class="list-disc list-inside ml-4">
              <li class="text-[16px] leading-[25px] font-normal text-[#372121]" [innerHTML]="'labels.usPropertyManaSubTitleGuest' | transloco"></li>
          </ul>

          <!--          luna nueva Home-->
          <div class="mt-[25px] sm:mt-[30px] font-semibold text-lg text-cafe">
            {{ 'labels.lunaNuevaHome' | transloco }}
          </div>
          <div class="text-base font-normal text-cafe">
            {{ 'labels.lunaNuevaHomeDescription' | transloco }}
          </div>

          <!--        compromiso social-->
          <div class="mb-[25px] mt-[25px] sm:mt-[31px] text-lg font-semibold text-verde sm:mb-[20px]">
            {{ 'labels.socialCommitment' | transloco }}
          </div>
          <div class="text-base font-normal text-cafe">
            {{ 'labels.socialCommitmentText' | transloco }}
          </div>

          <div class="mt-[22px] flex flex-row space-x-[14px] sm:mt-[25px] sm:space-x-[18px]">
            <ln-ln-fav-beige-svg-icon [class]="'h-[30px] w-[30px]'"></ln-ln-fav-beige-svg-icon>
            <div class="flex flex-col items-start">
              <div class="text-base font-semibold sm:text-lg text-cafe">
                {{ 'labels.freeEducationForOurCommunity' | transloco }}
              </div>
              <div class="text-base font-normal text-cafe">
                {{ 'labels.freeEducationForOurCommunityText' | transloco }}
              </div>
            </div>
          </div>

          <div class="mt-[22px] flex flex-row space-x-[14px] sm:mt-[25px] sm:space-x-[18px]">
            <ln-ln-fav-beige-svg-icon [class]="'h-[30px] w-[30px]'"></ln-ln-fav-beige-svg-icon>
            <div class="flex flex-col items-start">
              <div class="text-base font-semibold sm:text-lg text-cafe">
                {{ 'labels.trainingToOfferTraditionalBreakfasts' | transloco }}
              </div>
              <div class="text-base font-normal text-cafe">
                {{ 'labels.trainingToOfferTraditionalBreakfastsText' | transloco }}
              </div>
            </div>
          </div>

          <div class="mt-[22px] flex flex-row space-x-[14px] sm:mt-[25px] sm:space-x-[18px]">
            <ln-ln-fav-beige-svg-icon [class]="'h-[30px] w-[30px]'"></ln-ln-fav-beige-svg-icon>
            <div class="flex flex-col items-start">
              <div class="text-base font-semibold sm:text-lg text-cafe">{{ 'labels.spacesForLocalArt' | transloco }}</div>
              <div class="text-base font-normal text-cafe">{{ 'labels.spacesForLocalArtText' | transloco }}</div>
            </div>
          </div>
          <div class="mt-[25px] flex flex-row items-center justify-center sm:mt-[42px]">
            <ln-about-us-info-card></ln-about-us-info-card>
          </div>
          <div class="flex w-full justify-center items-center pt-[30px] pb-[46px] sm:pt-[35px] sm:pb-[29px]">
            <div class="flex flex-row justify-center items-start sm:items-center bg-blanco pb-[12px] pt-[16px] sm:pb-[14px] pl-[24px] pr-[19px] sm:pl-[24px] sm:pr-[23px] space-x-[15px] sm:space-x-[13px] rounded-[50px] sm:rounded-[30px]">
              <ln-volunteer-svg-icon [class]="'w-[30px] h-[30px]'"></ln-volunteer-svg-icon>
              <div class="text-cafe text-lg sm:text-xl font-medium">{{ 'messages.beingPartOfCommunity' | transloco }}</div>
            </div>
          </div>
          <div class="flex items-center border-b-[2px] border-b-verde opacity-40"></div>
        </div>
      </div>
    </div>
  </section>
</ln-ln-pages-armor>
